(() => {
  const MOBILE_QUERY = window.matchMedia('(max-width: 767px)');
  const WRAPPER_SELECTOR = '[data-section-heading-subheading]';
  const TEXT_SELECTOR = '[data-section-heading-subheading-text]';
  const TOGGLE_SELECTOR = '[data-section-heading-subheading-toggle]';

  const setExpanded = (wrapper, toggle, expanded, persist = false) => {
    wrapper.classList.toggle('is-expanded', expanded);
    wrapper.classList.toggle('is-collapsed', !expanded);
    toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    if (persist) {
      wrapper.dataset.sectionHeadingExpanded = expanded ? 'true' : 'false';
    }
  };

  const isTruncated = (text) => text.scrollHeight - text.clientHeight > 1;

  const updateWrapper = (wrapper) => {
    const text = wrapper.querySelector(TEXT_SELECTOR);
    const toggle = wrapper.querySelector(TOGGLE_SELECTOR);
    if (!text || !toggle) return;

    if (!MOBILE_QUERY.matches) {
      wrapper.classList.remove('is-truncated');
      setExpanded(wrapper, toggle, true);
      return;
    }

    wrapper.classList.remove('is-expanded');
    wrapper.classList.add('is-collapsed');

    const truncated = isTruncated(text);
    wrapper.classList.toggle('is-truncated', truncated);

    const shouldExpand = truncated ? wrapper.dataset.sectionHeadingExpanded === 'true' : true;
    setExpanded(wrapper, toggle, shouldExpand);
  };

  const bindWrapper = (wrapper) => {
    if (wrapper.dataset.sectionHeadingBound === 'true') return;
    wrapper.dataset.sectionHeadingBound = 'true';
    if (!wrapper.dataset.sectionHeadingExpanded) {
      wrapper.dataset.sectionHeadingExpanded = 'false';
    }

    const toggle = wrapper.querySelector(TOGGLE_SELECTOR);
    if (!toggle) return;

    toggle.addEventListener('click', () => {
      if (!wrapper.classList.contains('is-truncated')) return;
      const expanded = !wrapper.classList.contains('is-expanded');
      setExpanded(wrapper, toggle, expanded, true);
    });
  };

  const init = () => {
    const wrappers = Array.from(document.querySelectorAll(WRAPPER_SELECTOR));
    if (!wrappers.length) return;

    wrappers.forEach(bindWrapper);

    const updateAll = () => wrappers.forEach(updateWrapper);

    updateAll();
    window.addEventListener('resize', updateAll);
    window.addEventListener('load', updateAll);

    if (MOBILE_QUERY.addEventListener) {
      MOBILE_QUERY.addEventListener('change', updateAll);
    } else if (MOBILE_QUERY.addListener) {
      MOBILE_QUERY.addListener(updateAll);
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
